module.exports = __webpack_public_path__ + "static/estimote-8b97c796513da1c14487327a5ebd5947.png";